export { default } from './CardMedia';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/CardMedia/index.js
// module id = 317
// module chunks = 0